export const parseStaticsUrlFromEditorScriptUrl = (editorScriptUrl: string) => {
  const editorScriptUrlParts = editorScriptUrl.split('/')
  const staticsBaseUrl = editorScriptUrlParts.slice(0, editorScriptUrlParts.length - 1).join('/') + '/'
  return staticsBaseUrl
}
